export const reportTypes = [
  { value: "TWT", label: "Twitter" },
  { value: "URL", label: "Website" },
  { value: "eip155:1", label: "Ethereum Address" },
];
